import { api, apiUrl } from "../../shared/services/service";
import type {
  AdminCrewReportImportPayload,
  AdminCrewReportImportPreview,
  AdminCrewReportImportRunResult,
  AdminCrewReportRecipientResolution,
  AdminCrewReportRequestPayload,
  AdminCrewReportRequestResponse,
  AdminCrewReportStatisticsResponse,
  AdminCrewReportUploadOptionsResponse,
  AdminCrewReportUploadPayload,
  AdminCrewReportUploadResponse,
  AdminCrewReportVesselDetailsResponse,
  AdminCrewReportVesselCrewResponse,
  AdminCrewReportVesselOption,
  AdminCrewReportVesselsResponse,
} from "../models/admin-crew-report.models";

export const getAdminCrewReportStatistics = async (): Promise<AdminCrewReportStatisticsResponse> => {
  const response = await api.get<AdminCrewReportStatisticsResponse>(`${apiUrl}/admin/crew-report/statistics`);
  return response.data;
};

export const getAdminCrewReportReport = async (imoNumber: string): Promise<AdminCrewReportVesselCrewResponse> => {
  const response = await api.get<AdminCrewReportVesselCrewResponse>(`${apiUrl}/admin/crew-report/report`, {
    params: { imoNumber },
  });
  return response.data;
};

export const getAdminCrewReportImportPreview = async (
  allowTokenlessInitialImports: boolean,
): Promise<AdminCrewReportImportPreview> => {
  const response = await api.get<AdminCrewReportImportPreview>(`${apiUrl}/admin/crew-report/import-preview`, {
    params: { allowTokenlessInitialImports },
  });
  return response.data;
};

export const importAdminCrewReports = async (
  payload: AdminCrewReportImportPayload,
): Promise<AdminCrewReportImportRunResult> => {
  const response = await api.post<AdminCrewReportImportRunResult>(`${apiUrl}/admin/crew-report/import`, payload);
  return response.data;
};

export const getAdminCrewReportVessels = async (): Promise<AdminCrewReportVesselOption[]> => {
  const response = await api.get<AdminCrewReportVesselsResponse>(`${apiUrl}/admin/crew-report/vessels`);
  return response.data.vessels;
};

export const resolveAdminCrewReportRecipient = async (
  vessel: AdminCrewReportVesselOption,
): Promise<AdminCrewReportRecipientResolution> => {
  const response = await api.get<AdminCrewReportRecipientResolution>(`${apiUrl}/admin/crew-report/recipient`, {
    params: {
      vesselCode: vessel.vesselCode,
      imoNumber: vessel.imoNumber,
    },
  });
  return response.data;
};

export const requestAdminCrewReport = async (
  payload: AdminCrewReportRequestPayload,
): Promise<AdminCrewReportRequestResponse> => {
  const response = await api.post<AdminCrewReportRequestResponse>(`${apiUrl}/admin/crew-report/request`, payload);
  return response.data;
};

export const resolveAdminCrewReportBulkRequestRecipient = async (
  vessel: AdminCrewReportVesselOption,
): Promise<AdminCrewReportRecipientResolution> => {
  const response = await api.get<AdminCrewReportRecipientResolution>(
    `${apiUrl}/admin/crew-report/bulk-request/recipient`,
    {
      params: {
        vesselCode: vessel.vesselCode,
        imoNumber: vessel.imoNumber,
      },
    },
  );
  return response.data;
};

export const sendAdminCrewReportBulkRequest = async (
  payload: AdminCrewReportRequestPayload,
): Promise<AdminCrewReportRequestResponse> => {
  const response = await api.post<AdminCrewReportRequestResponse>(
    `${apiUrl}/admin/crew-report/bulk-request/send`,
    payload,
  );
  return response.data;
};

export const getAdminCrewReportVesselDetails = async (
  imoNumber: string,
): Promise<AdminCrewReportVesselDetailsResponse> => {
  const response = await api.get<AdminCrewReportVesselDetailsResponse>(`${apiUrl}/admin/crew-report/vessel-details`, {
    params: { imoNumber },
  });
  return response.data;
};

export const getAdminCrewReportUploadOptions = async (): Promise<AdminCrewReportUploadOptionsResponse> => {
  const response = await api.get<AdminCrewReportUploadOptionsResponse>(`${apiUrl}/admin/crew-report/upload-options`);
  return response.data;
};

export const submitAdminCrewReportUpload = async (
  payload: AdminCrewReportUploadPayload,
): Promise<AdminCrewReportUploadResponse> => {
  const response = await api.post<AdminCrewReportUploadResponse>(`${apiUrl}/admin/crew-report/upload`, payload);
  return response.data;
};
